export function AdminLedger() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <h1 className="text-2xl tracking-tight">Ledger</h1>
      <p className="text-[color:var(--mute)] mt-2">Append-only ledger search, reconciliation, exports. v3.1.</p>
    </div>
  );
}
